<template>
  <router-view v-if="isRouterAlive" />
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style lang="less">
body {
  font-family: NotoSansSC, Slack-Lato, Slack-Fractions, appleLogo, sans-serif;
}
</style>
